import { DataGrid as _DataGrid } from '@vooban/datagrid';
import React, { useRef, useEffect } from 'react';
import { DndContext } from 'react-dnd';
import AutoSizer from 'react-virtualized-auto-sizer';
import PropTypes from 'prop-types';
import { captureScrollPosition } from '../ListPage/helper';

const DataGrid = (props) => {
  const gridRef = useRef(null);
  const scrollRestorationAttempted = useRef(false);

  useEffect(() => {
    if (!props.scrollPosition || !gridRef.current || !props.data?.length) {
      return;
    }

    const { top } = props.scrollPosition;

    const attemptScrollRestoration = () => {
      const rdgElement = gridRef.current?.querySelector('.rdg');

      if (!rdgElement) {
        return;
      }
      const { scrollHeight, scrollTop } = rdgElement;
      if (!scrollRestorationAttempted.current && scrollTop === 0 && scrollHeight > 0) {
        const canRestore = scrollHeight >= top;

        if (canRestore) {
          rdgElement.scrollTop = top;
          scrollRestorationAttempted.current = true;

          if (props.unsetScrollPosition) {
            const currentPath = window.location.pathname;
            props.unsetScrollPosition(currentPath);
          }
        }
      }
    };

    requestAnimationFrame(attemptScrollRestoration);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.scrollPosition, props.data]);

  useEffect(() => {
    scrollRestorationAttempted.current = false;
  }, [props.scrollPosition?.top]);

  const handleRowClick = React.useCallback(
    (row, event) => {
      captureScrollPosition(props.setScrollPosition, props.take, gridRef.current);
      if (props.onRowClick) {
        props.onRowClick(row, event);
      }
    },
    [props]
  );

  return (
    <div className="flex-grow" style={{ minHeight: 0 }} ref={gridRef}>
      <AutoSizer style={{ minHeight: 300 }}>
        {({ height, width }) => (
          <DndContext.Consumer>
            {({ dragDropManager }) =>
              React.createElement(_DataGrid, {
                ...props,
                height,
                width,
                dragDropManager: dragDropManager,
                onRowClick: handleRowClick,
                setScrollPosition: undefined,
              })
            }
          </DndContext.Consumer>
        )}
      </AutoSizer>
    </div>
  );
};

DataGrid.propTypes = {
  scrollPosition: PropTypes.shape({
    top: PropTypes.number,
    height: PropTypes.number,
    take: PropTypes.number,
  }),
  data: PropTypes.arrayOf(PropTypes.any),
  setScrollPosition: PropTypes.func,
  onRowClick: PropTypes.func,
  take: PropTypes.number,
  unsetScrollPosition: PropTypes.func,
};

DataGrid.defaultProps = {
  scrollPosition: undefined,
  data: [],
  setScrollPosition: undefined,
  onRowClick: undefined,
  take: undefined,
  unsetScrollPosition: undefined,
};

export default DataGrid;
